import {seamlessBootstrap, seamlessImmutable} from 'epic-alt-utils/index';

import EulaActions from '../actions/EulaActions';
import EulaSource from '../sources/EulaSource';
import Immutable from 'seamless-immutable';
import alt from '../alt';
import {datasource} from 'alt-utils/lib/decorators';

@datasource(EulaSource)
@seamlessImmutable
class EulaStore {
    constructor() {
        this.on('error', (error) => {
            console.error(error);
        });
        this.on('bootstrap', seamlessBootstrap.bind(this, null));
        this.state = Immutable({
            loading: false,
            errorMessage: null,
            eula: null
        });
        this.bindActions(EulaActions);
    }

    onFetchEula() {
        this.getInstance().getLatest();
        return this.setState(this.state.set('loading', true));
    }

    onFetchEulaSuccess(response) {
        const newState = {
            loading: false,
            error: null
        };
        if (response.data && response.data.key) {
            newState.eula = response.data;
        }
        this.setState(this.state.merge(newState));
    }

    onFetchEulaFailure(response) {
        console.error('Failed to send 404 not found message.');
        const error = response.data.message;
        this.setState(this.state.merge({
            loading: false,
            error
        }));
    }
}

export default alt.createStore(EulaStore, 'EulaStore');
